import { useEffect } from 'react'
import { useFormModal } from '@/Ship/Hooks/useFormModal'

export const useCompleteRequestConfirm = ({ crudContext }: any) => {
    const { Modal, localStorage: completeModal } = useFormModal({
        fields: {},
        modalProps: {
            title: 'Завершити заявку',
            okText: 'Завершити заявку',
            okButtonProps: { type: 'primary' },
        },
        restUri: '/services/transport-requests/__uuid__/complete',
        restUriReplaceParams: (uri: string) =>
            uri.replace('__uuid__', crudContext?.formContext?.values?.uuid),
        requestSuccessMessage: 'Заявку завершено',
        onAfterSuccessRequest: () => crudContext?.actions?.reloadData?.(),
    })

    useEffect(() => {
        const em = crudContext?.eventManager
        if (!em) return

        em.on('requestAction:openCompleteConfirm', 'completeConfirmHandler', () => {
            completeModal.setIsModalOpen(true)
        })

        return () => em.off('requestAction:openCompleteConfirm', 'completeConfirmHandler')
    }, [crudContext, completeModal])

    return { Modal }
}
